import script from "./AdminClientesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminClientesPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminClientesPage.vue?vue&type=style&index=0&id=6c57522a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c57522a"]])

export default __exports__